import React from 'react';

import PreRequisites from './PreRequisites';
import StepForm from '../../form-designer/components/StepForm';

const MiddlePanel = ({ preRequisites, isStepFormLoading }) => {
  if (preRequisites) {
    const { columns, rows, totalRecordCount, translatedEntityName } = preRequisites;

    return (
      <PreRequisites
        columns={columns}
        rows={rows}
        totalRecordCount={totalRecordCount}
        entityName={translatedEntityName}
        hidePagination
      />
    );
  }

  return <StepForm isLoading={isStepFormLoading} />;
};

export default MiddlePanel;
